<template>
<div>
  <div class="title-bar title-h3 mr-r15">
    {{ title }} 어플리케이션 목록
  </div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <el-button class="mr-r4" size="mini" type="primary" :disabled="!isNodeFlag" @click="addApplication">추가</el-button>
      <el-button size="mini" :disabled="!checkChangeFlag" @click="deleteApplication">삭제</el-button>
    </div>
    <div class="vertical-center-box">
      <el-button :disabled="!checkChangeFlag" type="secondary" @click="openChangePopup" class="mr-r4">티어변경</el-button>
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-row class="mr-b20">
    <el-table-wrapper v-loading="isLoading" ref="applicationTable" @selection-change="applSelectionChange" row-class-name="c-dblclick" pagination :show-custom-header="true"
      :data="applDataList" :columns="applListColumns" :total="total" :column-default="columnDefault" :show-search-tool="showSearchTool" @condition-change="loadApplList" @cell-dblclick="onDbclickCell" />
  </el-row>
  <w-group-change-popup ref="groupChangePopup" current-tree-type="application" :selected-config-treekey="currentNode.treeKey" :selection-nodes="applSelection" @reloadData="reloadAllData" />
  <w-appl-setting-popup ref="applSettingPopup" :popup-type="applPopupType" @reloadData="reloadAllData" />
</div>
</template>

<script>
import { isNil, isEmpty, map } from 'lodash';
import { columnDefault } from '@/constants/table';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import msgUtil from '@/utils/message';
import WGroupChangePopup from '../components/popup/GroupChangePopup';
import WApplSettingPopup from '../components/popup/ApplSettingPopup';


export default {
  name: 'WApplicationSettingView',
  components: {
    WGroupChangePopup,
    WApplSettingPopup,
  },
  props: {
    currentNode: Object,
  },
  data() {
    return {
      columnDefault,
      applSelection: [],
      applPopupType: '',
      tierInfo: {},
      selectedConfigTreekey: null,
      checkChangeFlag: false,
      isLoading: false,
      showSearchTool: false,
      applDataList: null,
      total: 0,
      applListColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'applicationName',
          label: '어플리케이션명',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'count',
          label: '어플리케이션 URL',
        },
      ],
    };
  },
  computed: {
    title() {
      if (isEmpty(this.currentNode)) {
        return null;
      }
      return this.currentNode.tierId ? `[${this.currentNode.tierName}]` : null;
    },
    isNodeFlag() {
      return this.currentNode.type === 'group';
    },
  },
  watch: {
    currentNode: {
      immediate: true,
      handler(currentNode) {
        if (isEmpty(currentNode) || currentNode.type !== 'group') {
          return;
        }

        this.$nextTick(() => {
          this.loadApplList();
        });
      },
    },
  },
  methods: {
    /**
     * [loadApplList 티어 아이디에 따른 어플리케이션 목록을 조회한다.]
     * @author yelim
     */
    loadApplList() {
      if (!isNil(this.currentNode.tierId)) {
        this.isLoading = true;
        const tableParams = this.$refs.applicationTable.getParameter();
        ApmSettingAPI.getApplSettingList({ tierId: this.currentNode.tierId, ...tableParams }).then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.applDataList = response.data.data;
            this.total = response.data.total;
          } else {
            this.applDataList = [];
            this.total = 0;
          }
        });
      }
    },

    /**
     * [applSelectionChange 선택된 어플리케이션 리스트를 저장한다.]
     * @author yelim
     */
    applSelectionChange(row) {
      this.applSelection = row;
      if (this.isNodeFlag && row.length > 0) {
        this.checkChangeFlag = true;
      } else {
        this.checkChangeFlag = false;
      }
    },
    /**
     * [openChangePopup 노드가 속한 그룹의 정보를 바꾸기 위한 팝업 오픈]
     * @author yelim
     */
    openChangePopup() {
      this.$refs.groupChangePopup.open();
    },
    /**
     * [addApplication 트리타입이 어플리케이션인 경우, + 버튼으로 어플리케이션 추가 팝업을 open]
     * @author yelim
     */
    addApplication() {
      this.applPopupType = 'ADD';
      const tierInfo = {
        tierId: this.currentNode.tierId,
        tierName: this.currentNode.tierName,
      };
      this.$refs.applSettingPopup.open(tierInfo);
    },
    /**
     * [addApplication 트리타입이 어플리케이션인 경우, - 버튼으로 선택한 어플리케이션을 삭제한다.]
     * @author yelim
     */
    deleteApplication() {
      const deleteList = map(this.applSelection, 'applicationId');

      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        ApmSettingAPI.deleteAppl(deleteList).then((response) => {
          const result = response.data;
          if (result.success) {
            this.loadApplList();
            this.$emit('reloadTree');
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '어플리케이션', result.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '어플리케이션', false));
        });
      }).catch(() => {});
    },
    reloadAllData() {
      this.loadApplList();
      this.$emit('reloadTree');
    },
    /**
     * 어플리케이션 셀에서 더블클리하여 어플리케이션 변경 팝업창을 띄운다.
     * @param  {[type]} record [description]
     * @param  {[type]} column [description]
     * @return {[type]}        [description]
     * @author jda
     */
    onDbclickCell(record, column) {
      if (column.property !== 'applicationName') {
        return;
      }

      this.applPopupType = 'MODIFY';
      const tierInfo = {
        tierName: this.currentNode.tierName,
        ...record,
      };
      this.$refs.applSettingPopup.open(tierInfo);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/application/ApplicationSettingView.vue